(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-last-picked.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-last-picked.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsLastPicked = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_toplists_last_picked(data);
    },
    collectionEvents: {
      change: 'render'
    },
    regions: {
      toplistsLastPicked: '.js-receiver-toplists-last-picked'
    },
    tagName: 'div',
    className: 'last-picked-wrapper',

    onRender: function() {
      this.getRegion('toplistsLastPicked').show(new svs.grassroots.views.ReceiverToplistsLastPickedList({
        collection: this.options.collection
      }));
    }
  });
})(Backbone, _, svs);


 })(window);